"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.widget_handlers = void 0;
var utils_1 = require("../utils/utils");
exports.widget_handlers = [];
function init() {
    var widgets = document.getElementsByClassName('load-more-filter-widget');
    for (var i = 0; i < widgets.length; ++i) {
        var widget = widgets.item(i);
        if (!(widget instanceof HTMLElement))
            continue;
        exports.widget_handlers.push(new FilterWidgetHandler(widget));
    }
}
exports.init = init;
var FilterWidgetHandler = /** @class */ (function () {
    function FilterWidgetHandler(element) {
        var _this = this;
        this.element = element;
        this.target = null;
        /*
         * Get the elements
         */
        this.from_date_input = (0, utils_1.get_first_element_by_class_or_fail)(element, 'load-more-filter-widget__from-date-input', HTMLInputElement);
        this.from_date_clear = (0, utils_1.get_first_element_by_class_or_fail)(element, 'load-more-filter-widget__from-date-clear', HTMLButtonElement);
        this.to_date_input = (0, utils_1.get_first_element_by_class_or_fail)(element, 'load-more-filter-widget__to-date-input', HTMLInputElement);
        this.to_date_clear = (0, utils_1.get_first_element_by_class_or_fail)(element, 'load-more-filter-widget__to-date-clear', HTMLButtonElement);
        this.submit_button = (0, utils_1.get_first_element_by_class_or_fail)(element, 'load-more-filter-widget__submit', HTMLButtonElement);
        this.custom_inputs = Array.from(element.querySelectorAll('input.load-more-filter-widget__custom-input'));
        /*
         * Set values
         */
        this.from_date_value = this.from_date_input.value;
        this.to_date_value = this.to_date_input.value;
        this.custom_values = this.custom_inputs.reduce(function (result, element) {
            result[element.name] = element.value;
            return result;
        }, []);
        /*
         * Attach listeners
         */
        this.from_date_input.addEventListener("change", function () { return _this.update_ui(); });
        this.from_date_input.addEventListener("input", function () { return _this.update_ui(); });
        this.to_date_input.addEventListener("change", function () { return _this.update_ui(); });
        this.to_date_input.addEventListener("input", function () { return _this.update_ui(); });
        this.from_date_clear.addEventListener("click", function () {
            _this.from_date_input.value = "";
            _this.update_ui();
        });
        this.to_date_clear.addEventListener("click", function () {
            _this.to_date_input.value = "";
            _this.update_ui();
        });
        this.custom_inputs.forEach(function (element) {
            element.addEventListener('change', function () {
                _this.update_ui();
            });
            element.addEventListener("keypress", function (event) {
                // If the user presses the "Enter" key on the keyboard
                if (event.key === "Enter") {
                    // Cancel the default action, if needed
                    event.preventDefault();
                    // Trigger the button element with a click
                    var button = document.getElementById("load-more-filter-widget__submit__laboratory");
                    if (!!button) {
                        button.click();
                    }
                }
            });
        });
        this.submit_button.addEventListener('click', function () {
            _this.submit();
        });
        document.addEventListener('lgm.finish-load-more', function (event) {
            var _a;
            if (!(event instanceof CustomEvent))
                return;
            if (_this.target && _this.target !== ((_a = event.detail.target) === null || _a === void 0 ? void 0 : _a.resource))
                return;
            _this.force_update_filter_data(event.detail.parameters);
        });
    }
    FilterWidgetHandler.prototype.get_input_date_string_from_unix_timestamp = function (timestamp) {
        if (timestamp === 0)
            return "";
        var date = new Date(timestamp * 1000);
        return [
            date.getFullYear(),
            ("00" + (date.getMonth() + 1).toString()).substr(-2, 2),
            ("00" + date.getDate().toString()).substr(-2, 2),
        ].join('-');
    };
    FilterWidgetHandler.prototype.force_update_filter_data = function (parameter) {
        this.to_date_input.value = this.get_input_date_string_from_unix_timestamp(parameter.date_to);
        this.from_date_input.value = this.get_input_date_string_from_unix_timestamp(parameter.date_from);
        this.custom_inputs.forEach(function (element) {
            if (parameter.hasOwnProperty(element.name)) {
                element.value = parameter[element.name];
            }
            else {
                element.value = '';
            }
        });
        this.update_values_by_input_elements();
        this.update_ui();
    };
    FilterWidgetHandler.prototype.update_values_by_input_elements = function () {
        var _this = this;
        this.to_date_value = this.to_date_input.value;
        this.from_date_value = this.from_date_input.value;
        this.custom_inputs.forEach(function (element) {
            _this.custom_values[element.name] = element.value;
        });
    };
    FilterWidgetHandler.prototype.has_custom_filter_changed = function () {
        var _this = this;
        return this.custom_inputs.reduce(function (changed, element) {
            if (_this.custom_values[element.name] !== element.value) {
                return true;
            }
            return changed;
        }, false);
    };
    FilterWidgetHandler.prototype.has_filter_changed = function () {
        return this.has_custom_filter_changed()
            || this.from_date_value !== this.from_date_input.value
            || this.to_date_value !== this.to_date_input.value;
    };
    FilterWidgetHandler.prototype.update_ui = function () {
        if (this.from_date_input.value !== "") {
            this.from_date_clear.classList.remove('hidden');
            this.to_date_clear.setAttribute("min", this.from_date_clear.value);
        }
        else {
            this.from_date_clear.classList.add('hidden');
            this.to_date_clear.setAttribute("min", "");
        }
        if (this.to_date_input.value !== "") {
            this.to_date_clear.classList.remove('hidden');
            this.from_date_clear.setAttribute("max", this.to_date_clear.value);
        }
        else {
            this.to_date_clear.classList.add('hidden');
            this.from_date_clear.setAttribute("max", "");
        }
    };
    FilterWidgetHandler.prototype.get_filter_parameters = function () {
        return this.custom_inputs.reduce(function (params, element) {
            params[element.name] = element.value;
            return params;
        }, {
            target: this.target,
            date_from: this.from_date_input.value !== ""
                ? (new Date(this.from_date_input.value)).getTime() / 1000
                : 0,
            date_to: this.to_date_input.value !== ""
                ? (new Date(this.to_date_input.value)).getTime() / 1000
                : 0,
        });
    };
    FilterWidgetHandler.prototype.submit = function () {
        if (!this.has_filter_changed())
            return;
        var new_params = this.get_filter_parameters();
        var filter_event = new CustomEvent("lgm.filter", {
            detail: new_params
        });
        document.dispatchEvent(filter_event);
    };
    return FilterWidgetHandler;
}());
